export default "__VITE_ASSET__MltoNlJ0wXB11jxBULJk7w__"